import styled from "styled-components";

export const MainWrapper = styled.div`
  width: auto;
  height: 97.55vh;
  padding: 10px;
  background-image: url("/image/paternwave.png");
  overflow: hidden;
  &::-webkit-scrollbar {
    width: 2px;
    border-radius: 3px;
    background-color: #00000020;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #000000ce;
    width: 2px;
    border-radius: 3px;
  }
`;

export const CenteredObject = styled.div`
  width: auto;
  height: auto;
  height: 98vh;

  display: flex;
  justify-content: center;
  align-items: center;
`;

export const CenteredContent = styled.div`
  width: 40%;
  height: 90%;
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 728px) {
    width: 98%;
  }
`;

export const SlideShowSide = styled.div`
  width: auto;
  height: 45vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
`;

export const SlideContent = styled.div`
  width: 400px;
  height: 95%;

  @media (max-width: 728px) {
    width: 90%;
    height: 50vh;
  }
`;

export const SlideHolder = styled.div`
  height: 48vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
  /* justify-content: space-around; */

  @media (max-width: 728px) {
    gap: 20px;
    height: 48vh;
  }

  div:first-child {
    width: auto;
    height: 150px;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 120px;
    }
  }

  div:nth-child(2) {
    width: 200px;
    height: 100px;

    display: flex;
    align-items: center;
    justify-content: center;

    h2 {
      font-size: 2.5rem;
      line-height: 3rem;
      margin: auto;
      text-align: center;
    }
  }

  div:last-child {
    width: auto;
    height: 50px;

    p {
      font-size: 16px;
      color: black;

      @media (max-width: 728px) {
        font-size: 15px;
      }
    }
  }
`;

export const ProgressiveDot = styled.div`
  width: 100%;
  height: 30px;
  border: 1px solid black;
`;

export const BottomSide = styled.div`
  width: 342px;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
`;

export const DottedCircle = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: black;
`;
